import Alternative from './components/Alternative'
import Buttons from './components/Buttons'
import Card from './components/Card'
import Categories from './components/Categories'
import Description from './components/Description'
import Header from './components/Header'
import Info from './components/Info'
import LogoText from './components/LogoText'
import Media from './components/Media'
import MiniCard from './components/MiniCard'
import SavedCard from './components/SavedCard'
import Screenshots from './components/Screenshots'

const Listing = {
  Alternative,
  Buttons,
  Card,
  Categories,
  Description,
  Header,
  LogoText,
  Info,
  Media,
  MiniCard,
  Screenshots,
  SavedCard,
}

export default Listing
